/* ═══════════════════════════════════════════════════════
   KJELDSBERG BEAUTY — MAIN JS
   ═══════════════════════════════════════════════════════ */

document.addEventListener('DOMContentLoaded', () => {

  /* ── CART ─────────────────────────────────────────── */
  const drawer    = document.getElementById('cart-drawer');
  const cartItems = document.getElementById('cart-items');
  const cartTotal = document.getElementById('cart-total-price');
  const cartNote  = document.getElementById('cart-shipping-note');
  const FREE_SHIPPING = 69900; // øre (699 kr)

  function openCart()  { drawer?.setAttribute('aria-hidden','false'); document.body.style.overflow='hidden'; refreshCart(); }
  function closeCart() { drawer?.setAttribute('aria-hidden','true');  document.body.style.overflow=''; }

  document.querySelectorAll('[data-cart-open]').forEach(b => b.addEventListener('click', openCart));
  drawer?.querySelector('.drawer__close')?.addEventListener('click', closeCart);
  drawer?.querySelector('.drawer__backdrop')?.addEventListener('click', closeCart);

  function money(cents) {
    return (cents/100).toLocaleString('nb-NO',{style:'currency',currency:'NOK',minimumFractionDigits:0});
  }

  function updateBadge(n) {
    document.querySelectorAll('.cart-badge').forEach(el => {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  function renderCart(cart) {
    updateBadge(cart.item_count);
    if (cartTotal) cartTotal.textContent = money(cart.total_price);
    if (cartNote) {
      const diff = FREE_SHIPPING - cart.total_price;
      cartNote.textContent = diff > 0
        ? `Du mangler ${money(diff)} for fri frakt`
        : '✓ Du har fri frakt!';
      cartNote.style.color = diff > 0 ? 'var(--c-accent)' : 'var(--c-accent-dark)';
    }
    if (!cartItems) return;
    if (!cart.item_count) {
      cartItems.innerHTML = '<p class="cart-empty">Handlekurven er tom.</p>';
      return;
    }
    cartItems.innerHTML = cart.items.map(i => `
      <div class="cart-item">
        <img class="cart-item__img" src="${i.image||''}" alt="${i.product_title}">
        <div class="cart-item__info">
          <div class="cart-item__name">${i.product_title}</div>
          ${i.variant_title !== 'Default Title' ? `<div class="cart-item__price">${i.variant_title}</div>` : ''}
          <div class="cart-item__price">${money(i.price)}</div>
          <div class="cart-item__qty">
            <button class="qty-btn" data-key="${i.key}" data-qty="${i.quantity - 1}">−</button>
            <span class="qty-val">${i.quantity}</span>
            <button class="qty-btn" data-key="${i.key}" data-qty="${i.quantity + 1}">+</button>
          </div>
        </div>
      </div>`).join('');

    cartItems.querySelectorAll('.qty-btn').forEach(btn =>
      btn.addEventListener('click', () => changeQty(btn.dataset.key, +btn.dataset.qty)));
  }

  function refreshCart() {
    fetch('/cart.js').then(r=>r.json()).then(renderCart).catch(()=>{});
  }

  function changeQty(key, qty) {
    fetch('/cart/change.js',{
      method:'POST', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({id:key,quantity:qty})
    }).then(r=>r.json()).then(renderCart).catch(()=>{});
  }

  // Add to cart forms
  document.querySelectorAll('[data-atc-form]').forEach(form => {
    form.addEventListener('submit', e => {
      e.preventDefault();
      const btn = form.querySelector('[type=submit]');
      const orig = btn?.textContent;
      if (btn) { btn.textContent = 'Legger til…'; btn.disabled = true; }
      fetch('/cart/add.js',{method:'POST',body:new FormData(form)})
        .then(r=>r.json())
        .then(() => {
          if (btn) { btn.textContent = '✓ Lagt til'; setTimeout(()=>{ btn.textContent=orig; btn.disabled=false; },1500); }
          openCart();
        })
        .catch(()=>{ if(btn){ btn.textContent=orig; btn.disabled=false; } });
    });
  });

  /* ── PRODUCT SLIDER DOTS ─────────────────────────────── */
  document.querySelectorAll('.products-slider').forEach(slider => {
    const dotsWrap = slider.closest('.products-slider-wrap')?.querySelector('.slider-dots');
    if (!dotsWrap) return;
    const items = slider.querySelectorAll('.products-slider__item');
    if (items.length <= 1) return;

    items.forEach((_, i) => {
      const dot = document.createElement('button');
      dot.className = 'slider-dot' + (i === 0 ? ' active' : '');
      dot.setAttribute('aria-label', `Produkt ${i+1}`);
      dot.addEventListener('click', () => {
        items[i].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });
      dotsWrap.appendChild(dot);
    });

    slider.addEventListener('scroll', () => {
      const scrollLeft = slider.scrollLeft;
      const itemW = items[0]?.offsetWidth + 20;
      const active = Math.round(scrollLeft / itemW);
      dotsWrap.querySelectorAll('.slider-dot').forEach((d, i) => {
        d.classList.toggle('active', i === active);
      });
    }, { passive: true });
  });

  /* ── CART ICON WITH CONFETTI ─────────────────────────── */
  const CONFETTI_COLORS = ['#b89a7a','#f4c2c2','#1a1816','#e8ddd3','#d4a0a0','#f9e4b7'];

  function fireConfetti(container) {
    container.innerHTML = '';
    for (let i = 0; i < 22; i++) {
      const piece = document.createElement('div');
      piece.className = 'confetti-piece';
      piece.style.cssText = `
        left: ${20 + Math.random() * 60}%;
        top: ${10 + Math.random() * 40}%;
        background: ${CONFETTI_COLORS[Math.floor(Math.random() * CONFETTI_COLORS.length)]};
        animation-delay: ${Math.random() * .3}s;
        animation-duration: ${.7 + Math.random() * .5}s;
        width: ${5 + Math.random() * 6}px;
        height: ${5 + Math.random() * 6}px;
        border-radius: ${Math.random() > .5 ? '50%' : '2px'};
      `;
      container.appendChild(piece);
    }
    setTimeout(() => container.innerHTML = '', 1400);
  }

  document.querySelectorAll('.product-card__cart-btn').forEach(btn => {
    btn.addEventListener('click', e => {
      e.preventDefault();
      const vid = btn.dataset.quickAdd;
      if (!vid) return;

      const card = btn.closest('.product-card');
      const confettiEl = card?.querySelector('.product-card__confetti');
      const origHTML = btn.innerHTML;

      btn.innerHTML = `<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5"><path d="M20 6L9 17l-5-5"/></svg>`;
      btn.classList.add('added');
      if (confettiEl) fireConfetti(confettiEl);

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: vid, quantity: 1 })
      })
        .then(r => r.json())
        .then(() => {
          openCart();
          setTimeout(() => {
            btn.innerHTML = origHTML;
            btn.classList.remove('added');
          }, 1600);
        })
        .catch(() => {
          btn.innerHTML = origHTML;
          btn.classList.remove('added');
        });
    });
  });

  refreshCart();

  /* ── MOBILE NAV ───────────────────────────────────── */
  const mobileNav = document.querySelector('.mobile-nav');
  document.querySelector('.nav-hamburger')?.addEventListener('click', () => {
    mobileNav?.classList.toggle('open');
    document.body.style.overflow = mobileNav?.classList.contains('open') ? 'hidden' : '';
  });
  document.querySelector('.mobile-nav-close')?.addEventListener('click', () => {
    mobileNav?.classList.remove('open');
    document.body.style.overflow = '';
  });

  /* ── ACCORDION ────────────────────────────────────── */
  document.querySelectorAll('.accordion-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const isOpen = btn.classList.contains('open');
      document.querySelectorAll('.accordion-btn').forEach(b => { b.classList.remove('open'); b.nextElementSibling?.classList.remove('open'); });
      if (!isOpen) { btn.classList.add('open'); btn.nextElementSibling?.classList.add('open'); }
    });
  });

  /* ── GALLERY THUMBS ───────────────────────────────── */
  document.querySelectorAll('.gallery-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.gallery-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const main = document.querySelector('.gallery-main img');
      if (main) main.src = thumb.querySelector('img')?.src || '';
    });
  });

  /* ── VARIANT PICKER ───────────────────────────────── */
  document.querySelectorAll('.variant-opt').forEach(opt => {
    opt.addEventListener('click', () => {
      opt.closest('.variant-opts')?.querySelectorAll('.variant-opt').forEach(o => o.classList.remove('active'));
      opt.classList.add('active');
      const form = opt.closest('form');
      const input = form?.querySelector('[name=id]');
      if (input && opt.dataset.variantId) input.value = opt.dataset.variantId;
    });
  });

  /* ── MARQUEE CLONE ────────────────────────────────── */
  const track = document.querySelector('.marquee__track');
  if (track) track.innerHTML += track.innerHTML;

  /* ── SCROLL FADE IN ───────────────────────────────── */
  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach(e => {
        if (e.isIntersecting) { e.target.style.opacity='1'; e.target.style.transform='translateY(0)'; io.unobserve(e.target); }
      });
    }, { threshold: .08, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('.product-card, .testimonial, .usp, .section-header').forEach((el,i) => {
      el.style.cssText += `opacity:0;transform:translateY(20px);transition:opacity .55s ease ${i*.06}s,transform .55s ease ${i*.06}s`;
      io.observe(el);
    });
  }

  /* ── NEWSLETTER ───────────────────────────────────── */
  document.querySelector('.newsletter-form')?.addEventListener('submit', e => {
    e.preventDefault();
    const email = e.target.querySelector('[type=email]')?.value;
    if (!email) return;
    fetch('/contact',{method:'POST',headers:{'Content-Type':'application/x-www-form-urlencoded'},
      body: new URLSearchParams({form_type:'customer',utf8:'✓','contact[email]':email,'customer[accepts_marketing]':'true'})
    }).then(() => {
      e.target.innerHTML = '<p style="font-family:var(--font-heading);font-size:1.2rem;color:var(--c-accent)">Takk! Du er nå påmeldt. ✓</p>';
    }).catch(()=>{});
  });
});
